import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-top-row">
            <div className="footer-brand-column">
              <div className="footer-logo-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                  className="footer-logo-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 21c.5-4.5 2.5-8 7-10"></path>
                    <path d="M9 18c6.218 0 10.5-3.288 11-12V4h-4.014c-9 0-11.986 4-12 9c0 1 0 3 2 5z"></path>
                  </g>
                </svg>
                <span className="footer-brand-name">Evelynis</span>
              </div>
              <p className="footer-brand-story section-content">
                Handcrafted in Grampa&apos;s Wiltshire Workshop. A legacy of
                sustainable craftsmanship, building a timeless future one board
                at a time.
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div
                    aria-label="Follow us on Instagram"
                    className="footer-social-icon"
                  >
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                          width="20"
                          height="20"
                        ></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8A4 4 0 0 1 16 11.37m1.5-4.87h.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div
                    aria-label="Follow us on Facebook"
                    className="footer-social-icon"
                  >
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div
                    aria-label="Follow us on Pinterest"
                    className="footer-social-icon"
                  >
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m8 20l4-9m-1.3 3c.437 1.263 1.43 2 2.55 2c2.071 0 3.75-1.554 3.75-4a5 5 0 1 0-9.7 1.7"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0"></path>
                      </g>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-nav-grid">
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">Collections</h3>
                <ul className="footer-nav-list">
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Kitchen Boards</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Serving Platters</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Charcuterie Sets</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Seasonal Decor</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">Our World</h3>
                <ul className="footer-nav-list">
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>The Wiltshire Workshop</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Sustainability Promise</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Care &amp; Maintenance</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Our Story</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-nav-column">
                <h3 className="footer-nav-title">Support</h3>
                <ul className="footer-nav-list">
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Shipping &amp; Returns</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Gift Vouchers</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Custom Commissions</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Contact Grampa</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-newsletter-banner">
            <div className="footer-newsletter-content">
              <h2 className="section-title">Join our Workshop Journal</h2>
              <p className="section-content">
                Stories of wood, craft, and seasonal tradition delivered gently
                to your inbox.
              </p>
            </div>
            <form
              action="#"
              method="POST"
              data-form-id="6d21b1ea-7c80-4726-a018-c2d924d06f3f"
              className="footer-newsletter-form"
            >
              <div className="footer-input-group">
                <input
                  type="email"
                  id="thq_textinput_9lSU"
                  name="textinput"
                  required="true"
                  aria-label="Email for newsletter"
                  placeholder="Your email address"
                  data-form-field-id="thq_textinput_9lSU"
                  className="footer-input"
                />
                <button
                  id="thq_button_Zswd"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_Zswd"
                  className="btn-primary btn btn-lg"
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
          <div className="footer-bottom-bar">
            <p className="footer-copyright">
              &amp;copy; 2026 Evelynis. Wiltshire, England. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <a href="#">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Terms of Service</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Cookie Settings</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-newsletter-handler">
(function(){
  const footerForm = document.querySelector(".footer-newsletter-form")
  const footerInputGroup = document.querySelector(".footer-input-group")

  if (footerForm) {
    footerForm.addEventListener("submit", (e) => {
      e.preventDefault()

      const emailInput = footerForm.querySelector(".footer-input")
      const submitBtn = footerForm.querySelector("button")

      if (emailInput.checkValidity()) {
        const originalText = submitBtn.innerText
        submitBtn.disabled = true
        submitBtn.innerText = "Joining..."

        setTimeout(() => {
          footerInputGroup.innerHTML = \`
            <div style="padding: var(--spacing-md); color: var(--color-primary); font-weight: 500; text-align: center; width: 100%;">
              Welcome to the workshop journal. Check your inbox soon.
            </div>
          \`
        }, 800)
      }
    })

    const emailInput = footerForm.querySelector(".footer-input")
    emailInput.addEventListener("invalid", (e) => {
      e.preventDefault()
      footerInputGroup.style.borderColor = "#e74c3c"
      setTimeout(() => {
        footerInputGroup.style.borderColor = "var(--color-border)"
      }, 2000)
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
